import config from '../config';
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {DateTime} from 'luxon';

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: 'pragmatic',
      paths: [
        'lastContactUsSent'
      ],
    })
  ],

  state: {
    resolution: null,
    scroll: null,
    lastContactUsSent: null,  //iso datetime
    isMenuMainOpen: false,
    isTransitionInProgress: false,
    isGalleryOpen: false,
    galleryItems: [],
  },
  getters: {
    getLastContactUsSent: state => {
      return state.lastContactUsSent
    },

    getIsTransitionInProgress: state => {
      return state.isTransitionInProgress
    },
    getResolution: state => {
      return state.resolution
    },
    getScroll: state => {
      return state.scroll
    },
    getIsMenuMainOpen: state => {
      return state.isMenuMainOpen;
    },
    isBodyLocked: state => {
      let res = false;
      if (state.isMenuMainOpen) res = true;
      return res;
    },
    isHeaderSmall: state => {
      // if (state.resolution < 704 + 32) return true; //пусть даже на мобилах без скролла будет большим
      if (state.scroll > 30) return true
      return false;
    },
    getIsGalleryOpen: state =>{
      let res = state.isGalleryOpen
      return res;
    },
    getGalleryItems: state =>{
      let res = state.galleryItems
      return res;
    }
  },
  mutations: {
    setLastContactUsSent(state, newVal) {
      state.lastContactUsSent = newVal;
    },
    setIsTransitionInProgress(state, newVal) {
      state.isTransitionInProgress = newVal;
    },
    setResolution(state, newResolution) {
      state.resolution = newResolution;
    },
    setScroll(state, newScroll) {	//параметрический мутатор
      state.scroll = newScroll
    },
    setIsMenuMainOpen(state, bool) {
      state.isMenuMainOpen = bool
    },
    //newState: Boolean
    setIsGalleryOpen(state, newState) {
      state.isGalleryOpen = newState;
    },

    setGalleryItems(state, newItems) {
      state.galleryItems = newItems;
    },
  },

  strict: process.env.NODE_ENV == 'development',

})



// WEBPACK FOOTER //
// ./src/store/index.js